import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import { useDayRender, Button } from "react-day-picker";
import { format, isSameDay } from "date-fns";
import omit from "lodash/omit";
import classes from "../../css/styles.css";

// Custom day with improved accessibility
// See original: https://github.com/gpbl/react-day-picker/blob/master/packages/react-day-picker/src/components/Day/Day.tsx
const CustomDay = _ref => {
  let {
    date,
    displayMonth
  } = _ref;
  const buttonRef = React.useRef(null);
  const dayRender = useDayRender(date, displayMonth, buttonRef);
  const ariaLabel = format(date, 'EEEE MMMM do, yyyy');
  if (dayRender.isHidden) {
    return /*#__PURE__*/React.createElement("div", {
      role: "gridcell"
    });
  }
  if (!dayRender.isButton) {
    return /*#__PURE__*/React.createElement("div", dayRender.divProps);
  }
  const fixedButtonProps = omit(dayRender.buttonProps, ['role', 'aria-selected']);
  const isSelected = dayRender.buttonProps['aria-selected'];
  return /*#__PURE__*/React.createElement("div", {
    role: "gridcell",
    "aria-selected": isSelected,
    "aria-current": isSameDay(date, new Date()) ? 'date' : undefined,
    className: classes['grid-cell']
  }, /*#__PURE__*/React.createElement(Button, _extends({
    name: "day",
    ref: buttonRef,
    "aria-label": ariaLabel,
    "aria-pressed": isSelected || false
  }, fixedButtonProps)));
};
export default CustomDay;